export default class KeyboardLayout {

    static switch(str) {
        let isRussian = /[а-яё]+/i.test(str);

        let rus = [
            "й", "ц", "у", "к", "е", "н", "г", "ш", "щ", "з", "х", "ъ",
            "ф", "ы", "в", "а", "п", "р", "о", "л", "д", "ж", "э",
            "я", "ч", "с", "м", "и", "т", "ь", "б", "ю"
        ];

        let eng = [
            "q", "w", "e", "r", "t", "y", "u", "i", "o", "p", "\\[", "\\]",
            "a", "s", "d", "f", "g", "h", "j", "k", "l", ";", "'",
            "z", "x", "c", "v", "b", "n", "m", ",", "\\."
        ];

        for (let i = 0; i < rus.length; i++) {
            let pattern = isRussian ? rus[i] : eng[i];
            let reg = new RegExp(pattern, 'mig');
            str = str.replace(reg, a => {
                let s = isRussian ? eng[i] : rus[i]

                return a === a.toLowerCase() ?
                    s :
                    s.toUpperCase();
            });
        }

        return str;
    }

}